import React, { useEffect } from "react";
import '../../StoreDashboard/style.css'

const StoreSettingsPage = ({setActivePath}) => {
    useEffect(() => {
        setActivePath("Store Settings");
      }, [setActivePath]);


  return (
    <div className="outlet-container">
        <div id="google_translate_element" style={{ marginLeft: '10px' }}></div>
    </div>
  )
}

export default StoreSettingsPage
